import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import {Table} from 'react-bootstrap';
import moment from 'moment';
import SvgIcon from 'react-icons-kit';
import {bin} from 'react-icons-kit/icomoon/bin';
import {printer} from 'react-icons-kit/icomoon/printer';
import {pencil} from 'react-icons-kit/icomoon/pencil';
import {search} from 'react-icons-kit/icomoon/search';
import RaisedButton from 'material-ui/RaisedButton';
import ModalInfo from './modalInfo';

var Config = require('../../../config');

class PlasmaList extends Component{
	constructor(props){
		super(props);

		this.getList = this.getList.bind(this);
		this.addNew = this.addNew.bind(this);
		this.filtering = this.filtering.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onPrint = this.onPrint.bind(this);
		this.onDelete = this.onDelete.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onCheck = this.onCheck.bind(this);
		this.onGroup = this.onGroup.bind(this);
		this.printGroup = this.printGroup.bind(this);
		this.openInfo = this.openInfo.bind(this);
		this.openPrintList = this.openPrintList.bind(this);

		this.state = {
			list:[],
			filter:"",

			start_date:"",
			end_date:"",
			check_all: false,
		}
	}

	componentDidMount(){

		this.props.socket.onerror = (event)=> {
			console.log(event);
		};

		this.props.socket.onmessage = (event) => {
			var res = JSON.parse(event.data);
			if(res.Error === "No hay impresora configurada para imprimir")
				swal('¡Error!', res.Error, 'error');
		}


		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
			});

			this.getList();
		})

	}

	getList(){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'plasma_process?start_date='+this.state.start_date+
			'&end_date='+this.state.end_date,{
			method:'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				response.map((res)=>{
					res.check = false;
				});

				this.setState({list:response});
			}
		});
	}

	addNew(e){
		e.preventDefault();
		
		this.props.history.push('/plasmatic_products/plasma/new');
	}

	filtering(row){
		var valid = true;

		var string = row.folio+' '+row.national_center+' '+row.user_send;

		if(string.indexOf(this.state.filter.toUpperCase()) !== -1){
			valid = true;
		}else{
			valid = false;
		}

		return valid;
	}

	handleChange(e){
		if(e.target.name === 'check_all'){
			var list = this.state.list;

			list.map((l)=>{
				l.check = e.target.checked ? true : false;
			});

			this.setState({
				[e.target.name]: e.target.checked ? true : false, 
				list:list
			});
		}else{
			this.setState({[e.target.name]: e.target.value});	
		}
		
	}

	async onPrint(e, id){
		e.preventDefault();
		
		this.props.waiting.handleShow('Imprimiendo...');
				
		var obj ={};
		obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		obj.id = id;
		obj.file_type = 'plasma_process';
		obj.nEtiqueta = [0];

		var type = await this.props.getDocumentType(obj.file_type);

		var document;
		if(type.print_type === 'template'){
			document = await this.props.printDocumentTemplate(obj, type.print_automatically);
		}else if(type.print_type === 'external'){
			document = await this.props.printDocumentExternal(obj, type.print_automatically);
		}

		if(document !== undefined){
			this.props.waiting.handleClose();
			this.setState({aux_id:""});
		}else{
			this.props.waiting.handleClose();
		}
	
		
	}

	directPrint(response, type){
		//PRINTER
		var reader = new FileReader();
		reader.readAsDataURL(response); 
		reader.onloadend = ()=>{
			var base64data = reader.result;  
			var aux = base64data.split(',');
			this.props.socket.send('{"Operacion":"print", "Type":"'+type+'", "File": "'+aux[1]+'"}');
		}
	}

	onDelete(e, id){
		e.preventDefault();

		swal({
	        title: '¿Está seguro?',
	        text: '¿Seleccione una opción?',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: 'Eliminar!',
	        cancelButtonText: '¡Cancelar!',
	        closeOnConfirm: true,
	        closeOnCancel: true
	    },  (isConfirm)=> {
	        if (isConfirm) {
	        	this.props.waiting.handleShow('Cargando...');
				fetch(Config.default.apiGateway.URL+'plasma_process/'+id, {
		  			method : 'delete',
		  			headers: new Headers({
		  				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
		  				'Accept'		: 'application/json',
		  				'Content-Type'	: 'application/json'
		  			})
		  		}).then(res => {
		  			this.props.waiting.handleClose();
		  			if(res.ok){
		  				return res.json();
		  			}else{
		  				res.text().then((msg)=>{
		  					swal("Error", msg, 'error');
		  				})
		  			}
		  		})
		  		.then(response=>{
		  			if(response !== undefined){
		  				this.getList();
		  				swal('Success', 'El registro se elimino correctamente', 'success');
		  			}	
		  		})
	        }
	    });
	}

	onUpdate(e, id){
		this.props.history.push('/plasmatic_products/plasma/edit/'+id);
	}

	onCheck(e, i){
		var list = this.state.list;

		list[i].check = e.target.checked ? true : false;

		this.setState({list:list});
	}

	onGroup(){
		var obj = [];
		var origin = '';
		var error = '';
		this.state.list.map((l)=>{
			if(l.check){
				if(origin === ""){
					origin = l.national_center;
				}else if(origin !== l.national_center){
					error = 'No es posible agrupar cajas con diferentes destinos de envío';
				}
				
				if(error === ''){
					obj.push({plasma_process_id:l.id});
				}

			}
		});

		if(obj.length === 0){
			error = 'No ha seleccionado ningun elemento';
		}

		if(error === ""){
			this.props.waiting.handleShow('Agrupando...');
			fetch(Config.default.apiGateway.URL+'plasma_process_group',{
				method: 'POST',
				body: JSON.stringify(obj),
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){
					this.getList();
					swal('Correcto', 'Proceso terminado', 'success');
				}
			});
		}else{
			swal('Error', error, 'error');
		}
	}

	async printGroup(){
		this.props.waiting.handleShow('Imprimiendo...');
				
		var obj ={};
		obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		obj.ids = [];
		obj.file_type = 'plasma_group';
		obj.nEtiqueta = [0];

		this.state.list.map((l)=>{
			if(l.folio_group !== ""){
				var index = obj.ids.findIndex(obj => obj === l.folio_group);

				if(index === -1){
					obj.ids.push(l.folio_group);
				}
			}
		});

		var type = await this.props.getDocumentType(obj.file_type);

		var document;
		if(type.print_type === 'template'){
			document = await this.props.printDocumentTemplate(obj, type.print_automatically);
		}else if(type.print_type === 'external'){
			document = await this.props.printDocumentExternal(obj, type.print_automatically);
		}

		this.props.waiting.handleClose();
		
	
		
	}

	openInfo(e, id){
		e.preventDefault();

		this.modal_info.handleShow(id);
	}

	openPrintList(e, id){
		e.preventDefault();

		this.props.history.push('/plasmatic_products/plasma/print/'+id);
	}

	render(){
		const {t} = this.props;

		return(
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						Productos Hemostáticos ->
						Plasma a Industrializar
					</h5>
				</div>
				{/*<Help 
					{...this.props}
	                menu={"help_plasmatic_prod"} 
	                submenu={"help_plasmatic_discard"}  />
				*/}
				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-2">
						<span className="span-min">Fecha Inicial</span>
						<input type="date" name="start_date" id="start_date" value={this.state.start_date} onChange={this.handleChange}
							className="form-control " />
					</div>
					<div className="col-xs-12 col-sm-2">
						<span className="span-min">Fecha Final</span>
						<input type="date" name="end_date" id="end_date" value={this.state.end_date} onChange={this.handleChange}
							className="form-control " />
					</div>

					<div className="col-xs-12 col-sm-2" style={{marginTop:'18px'}}>
						<button className="btn btn-info" onClick={this.getList}>Buscar</button>
						<button className="btn btn-info" onClick={this.addNew} style={{marginLeft:'8px'}}>Nuevo</button>
					</div>
				</div>
				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-4">
						<input type="text" id="filter" name="filter" value={this.state.filter}
							onChange={this.handleChange} className="form-control" placeholder="Busqueda..."/>
					</div>
					
				</div>

				<div className="col-xs-12">
					<Table responsive hover>
						<thead>
							<tr>
								<th>
									<input type="checkbox" name="check_all" id="check_all" value={this.state.check_all}
										onChange={this.handleChange} checked={this.state.check_all} />
								</th>
								<th>No. Caja</th>
								<th>Fecha</th>
								<th>Hora</th>
								<th>Folio </th>
								<th>Sitio Envío</th>
								<th>Total Unidades</th>
								<th>Usuario Envia</th>
								<th>Estatus</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							{this.state.list.map((list, i)=>(
								this.filtering(list) ?
									<tr key={i}>
										<td>
											{list.status !== 'ALTA' ?
												<input type="checkbox" value={list.check}
													onChange={(e)=>this.onCheck(e, i)} checked={list.check}
													title={this.state.folio_group} />
											:null}
										</td>
										<td>{list.id}</td>
										<td>{moment(list.date).format('DD/MM/YYYY')}</td>
										<td>{moment(list.hour).format('HH:mm')}</td>
										<td>{list.folio}</td>
										<td>{list.national_center}</td>
										<td>{list.total_units}</td>
										<td>{list.user_send}</td>
										<td>{list.status}</td>
										<td>
											<button className="btn btn-info"  style={{marginRight:'8px'}}
												onClick={(e) => this.openInfo(e, list.id)}>
												<SvgIcon icon={search} size={15} />
											</button>

											{list.status === 'ALTA' ?
												<button className="btn btn-info"
													onClick={(e)=>this.onUpdate(e, list.id)}>
													<SvgIcon icon={pencil} size={15} />
												</button>
											:null}												

											<button className="btn btn-info"  style={list.status === 'ALTA' ? {marginLeft:'8px'} : {}}
												//onClick={(e) => this.onPrint(e, list.id)}
												onClick={(e) => this.openPrintList(e, list.id)}
												disabled={list.status === 'ALTA'}>
												<SvgIcon icon={printer} size={15} />
											</button>

											<button className="btn btn-info" style={{marginLeft:'8px'}}
												onClick={(e)=>this.onDelete(e, list.id)}>
												<SvgIcon icon={bin} size={15} />
											</button>
										</td>
									</tr>
								:null
							))}
						</tbody>
					</Table>
				</div>

				<div className="col-xs-12" style={{textAlign:'center'}}>
					<RaisedButton className="action-btn" label="Agrupar" 
						primary={true} onClick={this.onGroup}  style={{margin:12}}/>
	        		<RaisedButton className="action-btn" label={t('content.generics.buttons.print')} 
	        			primary={true} style={{margin:12}} 
	        			onClick={this.printGroup}
	        		/>
				</div>

				<ModalInfo {...this.props} onRef={ref => (this.modal_info = ref)} />

			</div>
		)
	}
}

export default translate('translations')(PlasmaList);